import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class InfosContact {
  constructor (
    raisonSociale?: string,
    email?: string,
    telephone1?: string,
    telephone2?: string,
    idPersonne?: number
  ) {
    this.raisonSociale = raisonSociale as any;
    this.email = email as any;
    this.telephone1 = telephone1 as any;
    this.telephone2 = telephone2 as any;
    this.idPersonne = idPersonne as any;
  }

  @JsonProperty(String)
  @Optional
  raisonSociale: string;

  @JsonProperty(String)
  @Optional
  email: string;

  @JsonProperty(String)
  @Optional
  telephone1: string;

  @JsonProperty(String)
  @Optional
  telephone2: string;

  @JsonProperty(Number)
  @Optional
  idPersonne: number;
}
